import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// vehicle_body_types — ประเภทตัวถัง
// ============================================================================
export const vehicleBodyTypes = sqliteTable("fleet_vehicle_body_types", {
  id: text("id").primaryKey(), // ULID
  name: text("name").notNull(),
  nameTh: text("name_th"),
  icon: text("icon"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type VehicleBodyType = typeof vehicleBodyTypes.$inferSelect;
export type NewVehicleBodyType = typeof vehicleBodyTypes.$inferInsert;
